import { createFormHookContexts } from '@tanstack/react-form'

export const { fieldContext, formContext,  useFormContext }
  = createFormHookContexts()
